/* @minVersion 7.3.2 */
/* @onlyBabel7 */

export default function _classStaticPrivateMethodSet() {
  throw new TypeError("attempted to set read only static private field");
}
